import React, { Component } from 'react';
import { connect } from "react-redux";

import ModalDevKey from '../user-profile/modal-developer-key'
import ModalConfirmDevKey from '../user-profile/modal-confirm-developer-key';
import ModalOauthSettings from '../modal-oauth-settings';
import ModalSamlSettings from '../modal-saml-settings';

class IntegrationSettings extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showDevKeyConfirmationModal: false,
      showDevKeyModal: false,
      showModalOauthSettings: false,
      showModalSamlSettings: false,
    };

    this.displayDevConfirmationModal = this.displayDevConfirmationModal.bind(this);
    this.closeDevConfirmationModal = this.closeDevConfirmationModal.bind(this);
    this.displayDevKeyModal = this.displayDevKeyModal.bind(this);
    this.closeDevModal = this.closeDevModal.bind(this);
    this.openModalOauthSettings = this.openModalOauthSettings.bind(this);
    this.closeModalOauthSettings = this.closeModalOauthSettings.bind(this);
    this.openModalSamlSettings = this.openModalSamlSettings.bind(this);
    this.closeModalSamlSettings = this.closeModalSamlSettings.bind(this);
  }

  displayDevConfirmationModal() {
    this.setState({
      showResetPasswordModal: false,
      savedPasswordMessage: null,
      showDevKeyConfirmationModal: true,
      showDevKeyModal: false
    });
  }

  closeDevConfirmationModal() {
    this.setState({ showDevKeyConfirmationModal: false });
  }

  displayDevKeyModal(){
    this.setState({
      showResetPasswordModal: false,
      savedPasswordMessage: null,
      showDevKeyConfirmationModal: false,
      showDevKeyModal: true
    });
  }

  closeDevModal(){
    this.setState({ showDevKeyModal: false })
  }

  openModalOauthSettings(event) {
    this.setState({showModalOauthSettings: true});
  }

  closeModalOauthSettings() {
    this.setState({showModalOauthSettings: false});
  }

  openModalSamlSettings(event) {
    this.setState({showModalSamlSettings: true});
  }

  closeModalSamlSettings() {
    this.setState({showModalSamlSettings: false});
  }

  render() {
    return (
      <React.Fragment>
        <div style={{ marginTop: '20px' }}>
          {this.props.session.user.admin && (
            <button type="button" className="btn btn-light-outline" onClick={this.displayDevConfirmationModal}>Generate Dev. Key</button>
          )}

          {this.props.session.user.admin && (
            <button type="button" className="btn btn-light-outline" onClick={this.openModalOauthSettings}>Edit Oauth Settings</button>
          )}

          {this.props.session.user.admin && (
            <button type="button" className="btn btn-light-outline" onClick={this.openModalSamlSettings}>Edit SAML Settings</button>
          )}
        </div>

        {this.state.showDevKeyConfirmationModal && this.props.session.user.admin &&
          <ModalConfirmDevKey
          displayDevKeyModal={this.displayDevKeyModal}
          onClose={this.closeDevConfirmationModal}
          />
        }

        {this.state.showDevKeyModal && this.props.session.user.admin &&
          <ModalDevKey
          user={this.props.session.user}
          onClose={this.closeDevModal}
          />
        }

        {this.state.showModalOauthSettings && this.props.session.user.admin &&
          <ModalOauthSettings
            isOpen={this.state.showModalOauthSettings}
            onClose={this.closeModalOauthSettings}
          />
        }

        {this.state.showModalSamlSettings && this.props.session.user.admin &&
          <ModalSamlSettings
            isOpen={this.state.showModalSamlSettings}
            onClose={this.closeModalSamlSettings}
          />
        }
      </React.Fragment>
    );
  }
}

const redux_state = state => ({
    session: state.session
});

const redux_actions = dispatch => ({
    dispatch: (action) => dispatch(action)
});

export default connect(redux_state, redux_actions)(IntegrationSettings);